import { BrowserRouter, Route, Routes } from 'react-router'

import { SliderStackProvider, TooltipProvider } from '@fv/client-components'

import { AuthenticatedApp } from './components/AuthenticatedApp'
import { Login } from './components/auth/Login'
import ErrorBoundary from './components/layout/ErrorBoundary'

export const App = () => {
  return (
    <TooltipProvider delay={300} closeDelay={300}>
      <div className="flex min-h-screen flex-col">
        <ErrorBoundary>
          <SliderStackProvider>
            <BrowserRouter>
              <Routes>
                <Route path="login" element={<Login />} />

                <Route path="*" element={<AuthenticatedApp />} />
              </Routes>
            </BrowserRouter>
          </SliderStackProvider>
        </ErrorBoundary>
      </div>
    </TooltipProvider>
  )
}
